import React, { useState, useEffect } from 'react';
import Header from '../homepage/header'; // Adjust the path if needed
import { API_BASE } from '../../apiConfig';
import projectsData from './projectsData.json'; // Import the local JSON file
import './Projects.css';

function Projects() {
  const [projectsList, setProjectsList] = useState({});
  const [expandedSections, setExpandedSections] = useState({});

  useEffect(() => {
    fetch(`${API_BASE}/projects`)
      .then((res) => {
        if (!res.ok) throw new Error();
        return res.json();
      })
      .then((data) => setProjectsList(data))
      .catch((err) => {
        console.log("Failed fetching dynamic projects, falling back to static:", err);
        setProjectsList(projectsData);
      });
  }, []);

  const toggleSection = (category) => {
    setExpandedSections((prevSections) => ({
      ...prevSections,
      [category]: !prevSections[category],
    }));
  };

  return (
    <div>
      <Header />
      <div className="header-container">
        <h1>Projects</h1>
      </div>
      <div className="projects-container">
        {Object.entries(projectsList).map(([category, items]) => (
          <div key={category} className="category">
            <h2 onClick={() => toggleSection(category)} className="expandable-heading">
              {category}
              <span className={`chevron ${expandedSections[category] ? 'rotate' : ''}`}>
                {expandedSections[category] ? '▲' : '▼'}
              </span>
            </h2>
            {expandedSections[category] && (
              <div className="items-grid">
                {items.map((item, index) => (
                  <div className="item" key={index}>
                    <h3>{item.projectTitle || item.title || item["Project Title"] || item["Title"]}</h3>
                    <p>
                      <strong>Funding Agency:</strong> {item.fundingAgency || item["Funding Agency"]}
                    </p>
                    <p>
                      <strong>Project Duration:</strong> {item.projectDuration || item["Project Duration"]}
                    </p>
                    <p>
                      <strong>Funding Amount:</strong> {item.fundingAmount || item["Funding Amount"]}
                    </p>
                    {/* <p>
                      <strong>Status:</strong> {item["Project Status"]}
                    </p> */}
                    {item.link && (
                      <a href={item.link} target="_blank" rel="noopener noreferrer">
                        View Details
                      </a>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default Projects;
